import { useEffect, useState } from "react";
import useApi from "./useApi";

interface BigCommerceConfig {
  id: number;
  displayName: string;
  storeName: string;
  storeUrl: string;
  enabled: boolean;
}

export default function useBigCommerceConfigs() {
  const [items, setItems] = useState<BigCommerceConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    async function fetchConfigs() {
      setLoading(true);
      try {
        const resp = await api.admin.get("BigCommerce/Configs");
        const data = await resp.json();
        setItems(Array.isArray(data) ? data : []);
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    }
    fetchConfigs();
  }, [api.admin]);

  return { items, loading };
}
